import { Component } from '@angular/core';
import { NotificationService } from '../../../../service';

@Component({
  standalone: false,
  selector: 'key-manager-view',
  templateUrl: './key-manager-view.component.html',
  styleUrls: ['./key-manager-view.component.scss']
})
export class KeyManagerViewComponent {
  constructor(private notificationService: NotificationService) {}

  public notify(msg: [string, string]): void {
    this.notificationService.success(msg[0], msg[1]);
  }
}
